export default "__VITE_ASSET__jleaGUyk__"